$(document).ready(function(){
    $(document).on('click', '.remove-position', function(){
        var data = $(this).data('id'), form = $(this).parents('form');
        form.append($('<input>',{
            type: 'hidden',
            name: 'remove',
            value: data
        })).append($('<input>',{
            type:'hidden',
            name:'step',
            value:'1'
        }));
        $('.save-packet').click();
        return false;
    }).on("change",".submit_form",function(){
        $(this).parents("form").submit();
    })

    $('#productIngredients').find('button').on('click', function(){
        var obj = {
            'header':  '<div class="product__ingredients__wrapper__infobox__header__title">'+$(this).find('.accordion-button__main__title').text()+'</div><div class="product__ingredients__infobox__header__subtitle">'+$(this).find('.accordion-button__main__subtitle').text()+'</div>',
            'body': $(this).closest('.accordion-item').find('.accordion-body').html(),
        }
        copyContent('#productIngredientsInfobox', obj);
    })

    // $('#productIndications').find('button').on('click', function(){
    //     var obj = {
    //         'header': '<div class="product__characteristics__indications__content__accordion-wrapper__infobox__header__title">'+$(this).text()+'</div>',
    //         'body': '<p>'+$(this).closest('.accordion-item').find('.accordion-body').find('p').html()+'</p>',
    //         'footer': '<a href="'+$(this).closest('.accordion-item').find('.accordion-body a').attr('href')+'">'+$(this).closest('.accordion-item').find('.accordion-body a').text()+'</a>'
    //     }
    //     copyContent('#productIndicationsInfobox', obj);
    // })

    addToCartController()
    $(window).on('scroll', addToCartController)

    var productIngredientsClickTarget = 'productIngredients-collapse-0';
    // var productIndicationsClickTarget = 'productIndications-collapse-0';

    $('#productIngredients').on('show.bs.collapse', (e) => {
        productIngredientsClickTarget = e.target.id;
    })

    // $('#productIndications').on('show.bs.collapse', (e) => {
    //     productIndicationsClickTarget = e.target.id;
    // })

    $('#productIngredients').on('hide.bs.collapse', (e)=>{
        if(e.target.id == productIngredientsClickTarget){
            return e.preventDefault()
        }
    })

    // $('#productIndications').on('hide.bs.collapse', (e)=>{
    //     if(e.target.id == productIndicationsClickTarget){
    //         return e.preventDefault()
    //     }
    // })

    $('#productIngredients').children().first().find('.accordion-button').click();
    // $('#productIndications').children().first().find('.accordion-button').click();

    $('.product__characteristics__indications__content__action button').on('click', () => {
        if($('.product__characteristics__indications__content__accordion-wrapper').hasClass('rolled-up')){
            $('.product__characteristics__indications__content__accordion-wrapper').css('height', $('.product__characteristics__indications__content__accordion-wrapper__accordion').height()+'px')
        } else {
            $('.product__characteristics__indications__content__accordion-wrapper').css('height', '324px')
        }
        $('.product__characteristics__indications__content__accordion-wrapper').toggleClass('rolled-up');
        $('.product__characteristics__indications__content__action button').find('span').toggleClass('d-none');
    })

    $('.product__characteristics__indications .accordion-button').on('click', function(){
        $('.product__characteristics__indications__content__action button').find('#btn-text-more').addClass('d-none');
        $('.product__characteristics__indications__content__action button').find('#btn-text-less').removeClass('d-none');
        setTimeout(()=>{
            $('.product__characteristics__indications__content__accordion-wrapper').css('height', $('.product__characteristics__indications__content__accordion-wrapper__accordion').height()+'px')
            $('.product__characteristics__indications__content__accordion-wrapper').removeClass('rolled-up');
        }, 400)
    })
})

function copyContent(box_id, content){
    if(content.header){
        $(box_id+'Header').html(content.header);
    }
    if(content.body){
        $(box_id+'Body').html(content.body);
    }
    if(content.footer){
        $(box_id+'Footer').html(content.footer);
    }
}

function addToCartController(){
    const wrapper = $('#product-add-to-cart-wrapper')
    const desktopWrapper = $('#product-main-form-desktop-scroll')
    if (!wrapper.length) {
        return
    }

    if(wrapper.position().top + 89 <= $(window).scrollTop() + $(window).height()){
        wrapper.children('.product__main__form__add-to-cart').addClass('fixed')
    } else {
        wrapper.children('.product__main__form__add-to-cart').removeClass('fixed')
    }

    if(wrapper.position().top - 89 <= $(window).scrollTop() - 113) {
        desktopWrapper.addClass('fixed')
    } else {
        desktopWrapper.removeClass('fixed')
    }
}

function addToFavoriteAfterClick(elem, response){
    if(response.status){
        $(elem.inv).addClass('active');
    }else{
        $(elem.inv).removeClass('active');
    }
    if(response.favoriteProductsCount !== undefined){
        $('.favorite-products-count').html(response.favoriteProductsCount);
    }
}

